"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBaseProjectAction = void 0;
const typeguards_1 = require("au-types/lib/typeguards");
const typeguard_1 = require("../types/typeguard");
const baseProjectActionRuleSet = {
  type: typeguard_1.isNonEmptyString,
  timestamp: typeguard_1.isISODateString,
  projectId: typeguard_1.isNonEmptyString,
  mobile: (0, typeguard_1.optional)(typeguard_1.isBool),
  currentProjectVersion: (0, typeguard_1.optional)(typeguards_1.isNumber)
};
const isBaseProjectAction = p => (0, typeguard_1.isType)(p, baseProjectActionRuleSet);
exports.isBaseProjectAction = isBaseProjectAction;